import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { ApiPaginationResponseDataNonNullable, ApiResponseDataNonNullable } from "app/shared/models/api-response.model";
import { Observable } from "rxjs";
import { AuthService } from "../../base-module/base-service/auth.service";
import { UtilitesService } from "../../base-module/base-service/utilites.service";
import { ServicoModel } from "../models/servico.model";

@Injectable()
export class ServicoService {
    constructor(private authService: AuthService, private _http: HttpClient, public utilitesService: UtilitesService) {}

    /**
     * Serviço por id
     * @param id ID do serviço
     */
    getById(id: number): Observable<ApiResponseDataNonNullable<ServicoModel>> {
        return this._http.get<ApiResponseDataNonNullable<ServicoModel>>(
            this.utilitesService.urlPrefix + "servico/" + id,
            {
                headers: this.authService.getAuthHeaders(),
            }
        );
    }

    /**
     * Lista de Serviços
     * @param id ID do serviço
     */
    getAll(params: any): Observable<any> {
        const paramHttp = this.utilitesService.formurlencoded(params);
        let env = "";
        if (paramHttp !== null && paramHttp !== "") {
            env = "?" + paramHttp;
        }

        return this._http.get(this.utilitesService.urlPrefix + "servico" + env, {
            headers: this.authService.getAuthHeaders(),
        });
    }

    /**
     * Lista de Ativo Para Campo Do Cadastro de Cliente
     */
    getLista(): Observable<ApiPaginationResponseDataNonNullable<ServicoModel>> {
        return this._http.get<ApiPaginationResponseDataNonNullable<ServicoModel>>(
            this.utilitesService.urlPrefix + "servico/lista",
            {
                headers: this.authService.getAuthHeaders(),
            }
        );
    }

    /**
     * Delete de Serviço
     * @param id ID do serviço
     */
    delete(id: number): Observable<any> {
        return this._http.delete(this.utilitesService.urlPrefix + "servico/" + id, {
            headers: this.authService.getAuthHeaders(),
        });
    }

    /**
     * Cadastra Serviço
     * @param params Json Serviço
     */
    create(params: any): Observable<any> {
        return this._http.post(this.utilitesService.urlPrefix + "servico", JSON.stringify(params), {
            headers: this.authService.getAuthHeaders(),
        });
    }

    /**
     * Atualiza Serviço
     * @param params Json Serviço
     */
    update(id: number, params: any): Observable<any> {
        return this._http.put(this.utilitesService.urlPrefix + "servico/" + id, JSON.stringify(params), {
            headers: this.authService.getAuthHeaders(),
        });
    }
}
